export default "__VITE_ASSET__679d7212__"